import type { PopoverProps as MuiPopoverProps } from "@mui/material";
import { Popover as MuiPopover } from "@mui/material";
import { useCallback, useState } from "react";

export const Popover = MuiPopover;

export type PopoverProps = MuiPopoverProps & {
  popoverButton: React.ReactNode;
};

export const PopoverWithButton = (props: PopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  return (
    <>
      <div onClick={handleClick}>{props.popoverButton}</div>
      <MuiPopover {...props} anchorEl={anchorEl} />
    </>
  );
};
